
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as homeqS_45WahBda7slckAMlPtS_YZqHAQR8Q_Nwgb742LrTmsMeta } from "/srv/sarvban_front/pages/home.vue?macro=true";
import { default as testcK3hcfoFfRjG44Sytro2zewf_05VUo7OJW_45Q4GspNe8Meta } from "/srv/sarvban_front/pages/test.vue?macro=true";
import { default as zaraX9z_5p_hPQ7eUmmucSCYa5T8RDB6G7iZd7DLQy2wcHEMeta } from "/srv/sarvban_front/pages/zara.vue?macro=true";
import { default as indexAfZPcIGjex36u_45h3_5I1vYFEUqtgel9doKNEiXzYu6sMeta } from "/srv/sarvban_front/pages/index.vue?macro=true";
import { default as loginWU9TCd0o15itMo5byf0_45w7ob6tWae2Hzv3ns33occCsMeta } from "/srv/sarvban_front/pages/login.vue?macro=true";
import { default as logoutShMXtDZ0AeKbS1PLFmEoJgc_45zW4b6Al5hDFith0_45DpkMeta } from "/srv/sarvban_front/pages/logout.vue?macro=true";
import { default as contactV0pyyYd0y1jj3qGHW0N_mOwSRG28pLS_45Y2v6gI72YnwMeta } from "/srv/sarvban_front/pages/contact.vue?macro=true";
import { default as landingBn_45yLbN9nxfqCbEHbz4fkSe04aRKCJXdhWP4ujShLKEMeta } from "/srv/sarvban_front/pages/landing.vue?macro=true";
import { default as pricebptVGvheuwrhxHACFdL2POzHtXBR34FT9AtwQXzJaLm7AMeta } from "/srv/sarvban_front/pages/pricebp.vue?macro=true";
import { default as agrimentmKDtKSPOllrWeJG8y1yQLHEUSEEAxi7aazswePFWnOYMeta } from "/srv/sarvban_front/pages/agriment.vue?macro=true";
import { default as homepageqovwQjsJlY0N_s0BBDDKNx0cIVTWwcxxCLvyy_45yqrIkMeta } from "/srv/sarvban_front/pages/homepage.vue?macro=true";
import { default as registerJsWs_458P8DGBq4qhxUsY3zxvDVayxV3VFd_45zNAOnF5J0Meta } from "/srv/sarvban_front/pages/register.vue?macro=true";
import { default as indexXNIFQM2rRMqZYz6H3CraMRo_45gd5bjfeigeYD3bJOtqEMeta } from "/srv/sarvban_front/pages/blog/index.vue?macro=true";
import { default as _91id_93gzx8MdOVJboUwBRVOnNk4xsM4YLbZfC5Mnf3EjfRNoAMeta } from "/srv/sarvban_front/pages/order/[id].vue?macro=true";
import { default as _91slug_93s2VCYhyPmkvpYB_jgaXP_YKg3T8T0KfC9ZZt4Dp6Xn4Meta } from "/srv/sarvban_front/pages/blog/[slug].vue?macro=true";
import { default as _91id_93iLVflF_45Vxb4UT_45R1YOm58110TPCVtP4ST2osQxi8OAgMeta } from "/srv/sarvban_front/pages/details/[id].vue?macro=true";
import { default as farm_45monitor2jID9FlzBYE6UE4aHubuYzIIqtrZKoEKZtyxKNsAC0UMeta } from "/srv/sarvban_front/pages/farm-monitor.vue?macro=true";
import { default as _91id_93WUxyZMAy5GE72p0yddZIAfmOpBZoWCk_ojB4XpVjefkMeta } from "/srv/sarvban_front/pages/invoice/[id].vue?macro=true";
import { default as _91key_93UVTwaEjlBkNcr02Kk1OVA6NWxCuWhEBZ9vixqZx7T0gMeta } from "/srv/sarvban_front/pages/search/[key].vue?macro=true";
import { default as about_45sarvbanWXNffdCvg7cnVs_6GZXHTlLa1hPxzA54PMFOE4dNXR4Meta } from "/srv/sarvban_front/pages/about-sarvban.vue?macro=true";
import { default as indext2S1_45x3JXJT_45G5MKOn6C9IuhWsLG0sMAtuRsgqkvWmgMeta } from "/srv/sarvban_front/pages/add-ads/index.vue?macro=true";
import { default as index1tQtfJ_45YDBmtfRVtKnWoa9kxkJrZnO0Gjxo2ndqAnYoMeta } from "/srv/sarvban_front/pages/add-adv/index.vue?macro=true";
import { default as indexx231sfLaiIvoyuClKUf0irULWcGAxmjbpKJmeCyLHB0Meta } from "/srv/sarvban_front/pages/add-ord/index.vue?macro=true";
import { default as test_45contractg287Eq06cW2xxVCDHfKv2BC8GI42ezndGThyDwY3mJUMeta } from "/srv/sarvban_front/pages/test-contract.vue?macro=true";
import { default as about_45servicesN5UdkfQWbHNxHbvlIOVRfes63ovkFWQDuEKLEdKoTqkMeta } from "/srv/sarvban_front/pages/about-services.vue?macro=true";
import { default as verifyzoarlf_mOu857IJWdkYYeFyLZzcTd4gHSZxNPDjAkm8Meta } from "/srv/sarvban_front/pages/payment/verify.vue?macro=true";
import { default as indexW7rgoRbuIGuvnE1r49B8BvLcOysFNrEDlYqoM0aw1BgMeta } from "/srv/sarvban_front/pages/products/index.vue?macro=true";
import { default as invoicePT3eqYnaGKM9TcNAzWI_X2K3FOvMcUoebqS8XVzrQnEMeta } from "/srv/sarvban_front/pages/payment/invoice.vue?macro=true";
import { default as seller7mDZGNb68BwoGj7wm_Xq7xFzur8Dv04FR2zZkX5ktHUMeta } from "/srv/sarvban_front/pages/products/seller.vue?macro=true";
import { default as contract_45builderNKd1j1euOn0EtrItZsRSxrle5h_D87UhYiNgyZppb1wMeta } from "/srv/sarvban_front/pages/contract-builder.vue?macro=true";
import { default as index0yGb_45CXKJTn_45kUv8nHCImohOqLiiN1ldcchtU4SjMNgMeta } from "/srv/sarvban_front/pages/my-sarvban/index.vue?macro=true";
import { default as ordersv9EDdbxMczfA_22HFTcT2KyIRJa0PxZfX1r_45bdoMp9YMeta } from "/srv/sarvban_front/pages/my-sarvban/orders.vue?macro=true";
import { default as walletwRfnsh5xivzUHgAclcJMqK7GrwhRTdbvGM411Sa6WzQMeta } from "/srv/sarvban_front/pages/my-sarvban/wallet.vue?macro=true";
import { default as servicesC6qcNSEXa_PtWXwjtzdAlEZe0NW5LdNuQp77e0r41D8Meta } from "/srv/sarvban_front/pages/products/services.vue?macro=true";
import { default as _91city_937u1LMp_hw6TiCcvKxsQWfPNBrj2IFn5Z4fmN_hWk3fAMeta } from "/srv/sarvban_front/pages/region/bar/[city].vue?macro=true";
import { default as index_U8zR9ztaewW_45A21u3mN4V8czgJG2xHsqQ2iF3TZecIMeta } from "/srv/sarvban_front/pages/add-ads/edit/index.vue?macro=true";
import { default as indexD6lGfNkBxFetr7Y7y_45WlIQ_GY3weqQFBftaVqd_BEocMeta } from "/srv/sarvban_front/pages/add-adv/edit/index.vue?macro=true";
import { default as profilefFn307o26DIiGZzTsLX56Be_45pMnIy0tW9VKFm1X_45iAMMeta } from "/srv/sarvban_front/pages/my-sarvban/profile.vue?macro=true";
import { default as relatedYsMT5DSgSwx2VQwL7ZVtNxipYEXcqm76jkYpL8bvrCoMeta } from "/srv/sarvban_front/pages/my-sarvban/related.vue?macro=true";
import { default as sonZ5jMgV1k3jtl8hOeqkcznv0nNxWhfipvYFgyCrMsRwoMeta } from "/srv/sarvban_front/pages/region/amayesh/son.vue?macro=true";
import { default as messagesT3v_Vw6IKp8FJ61wmuq9_a7jTUrYj4RzXauKaR2QiikMeta } from "/srv/sarvban_front/pages/my-sarvban/messages.vue?macro=true";
import { default as servicesmxqdX2eyiG09RsKjjRUB2bn3negEfUPFnsortdakJcAMeta } from "/srv/sarvban_front/pages/my-sarvban/services.vue?macro=true";
import { default as verify_45test17sdCwThmPWGWQV94CWE5p9P3dlUxo3rc5uL0mYIMOYMeta } from "/srv/sarvban_front/pages/payment/verify-test.vue?macro=true";
import { default as _91slug_934rK6E2t3wEfCoaJZp0bss9_45NraYoH3hLlB9sSVDEnd4Meta } from "/srv/sarvban_front/pages/blog/category/[slug].vue?macro=true";
import { default as indexCBevLlv_45fM_45es4h3LDnBHiLledtTkhrlHIVHBkUcBCAMeta } from "/srv/sarvban_front/pages/my-sarvban/adv/index.vue?macro=true";
import { default as index41JDNsTjhTnzC3TRQFlWSp1OxRwri8hjmg_45aVdDK86cMeta } from "/srv/sarvban_front/pages/region/amayesh/index.vue?macro=true";
import { default as zchatARo7T5oxisehXMb0UOaBVv_P6C_5rAm4vMV6WzwXf70Meta } from "/srv/sarvban_front/pages/region/amayesh/zchat.vue?macro=true";
import { default as price_45bidsiXKIGvi9PTULXLKgrdZ2TmhVKrEhdjezg6cF_45W_45ZJa4Meta } from "/srv/sarvban_front/pages/my-sarvban/price-bids.vue?macro=true";
import { default as outofseasionIk909H6mz1QUFSDynGwyW40tRsORwNYF_45gh78lP3txkMeta } from "/srv/sarvban_front/pages/products/outofseasion.vue?macro=true";
import { default as buyers_45listRGw2VdZuPDbMvfT8Fvqj4ottLnNF9p8SKkeSSedae14Meta } from "/srv/sarvban_front/pages/my-sarvban/buyers-list.vue?macro=true";
import { default as number_45listTwhHsY4kIoGQFEczIoUKx819uBZt3S57VWCBrA6PjqkMeta } from "/srv/sarvban_front/pages/my-sarvban/number-list.vue?macro=true";
import { default as _91id_93sSeCV_45y1jNlbuQ5UoCBUFVxmKem8tbstLBxCuJIcgpIMeta } from "/srv/sarvban_front/pages/my-sarvban/adv/edit/[id].vue?macro=true";
import { default as _91id_93ac_KhBwG9LR6d7RCqRmdY1S4v5VLtPTVinZmFBkFUK8Meta } from "/srv/sarvban_front/pages/my-sarvban/broadcast-ord/[id].vue?macro=true";
import { default as listrAQaIK_45B66uVqLiRoCL8Rs7zBt_456e2TJQH6bgcJLj5UMeta } from "/srv/sarvban_front/pages/my-sarvban/broadcast-ord/list.vue?macro=true";
import { default as indexU9BAq6zIocuPkIULCMSOZ7eZJXcRMt1qEYBFEjUT_IYMeta } from "/srv/sarvban_front/pages/my-sarvban/buy-requests/index.vue?macro=true";
import { default as indexTHZv2_45nOJgs23lb_GVgXYrKB10BJOXU1fGQm6p2HkrsMeta } from "/srv/sarvban_front/pages/my-sarvban/broadcast-ord/index.vue?macro=true";
import { default as _91id_939wRsc9EUOYJlyyyt3ILuwU_45KfB0uqw5eDvtd9NowjGkMeta } from "/srv/sarvban_front/pages/my-sarvban/buy-requests/edit/[id].vue?macro=true";
import { default as component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta } from "/srv/sarvban_front/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08 } from "/srv/sarvban_front/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "home___fa",
    path: "/home",
    meta: homeqS_45WahBda7slckAMlPtS_YZqHAQR8Q_Nwgb742LrTmsMeta || {},
    component: () => import("/srv/sarvban_front/pages/home.vue")
  },
  {
    name: "home___en",
    path: "/en/home",
    meta: homeqS_45WahBda7slckAMlPtS_YZqHAQR8Q_Nwgb742LrTmsMeta || {},
    component: () => import("/srv/sarvban_front/pages/home.vue")
  },
  {
    name: "home___ar",
    path: "/ar/home",
    meta: homeqS_45WahBda7slckAMlPtS_YZqHAQR8Q_Nwgb742LrTmsMeta || {},
    component: () => import("/srv/sarvban_front/pages/home.vue")
  },
  {
    name: "home___ru",
    path: "/ru/home",
    meta: homeqS_45WahBda7slckAMlPtS_YZqHAQR8Q_Nwgb742LrTmsMeta || {},
    component: () => import("/srv/sarvban_front/pages/home.vue")
  },
  {
    name: "home___tr",
    path: "/tr/home",
    meta: homeqS_45WahBda7slckAMlPtS_YZqHAQR8Q_Nwgb742LrTmsMeta || {},
    component: () => import("/srv/sarvban_front/pages/home.vue")
  },
  {
    name: "test___fa",
    path: "/test",
    meta: testcK3hcfoFfRjG44Sytro2zewf_05VUo7OJW_45Q4GspNe8Meta || {},
    component: () => import("/srv/sarvban_front/pages/test.vue")
  },
  {
    name: "test___en",
    path: "/en/test",
    meta: testcK3hcfoFfRjG44Sytro2zewf_05VUo7OJW_45Q4GspNe8Meta || {},
    component: () => import("/srv/sarvban_front/pages/test.vue")
  },
  {
    name: "test___ar",
    path: "/ar/test",
    meta: testcK3hcfoFfRjG44Sytro2zewf_05VUo7OJW_45Q4GspNe8Meta || {},
    component: () => import("/srv/sarvban_front/pages/test.vue")
  },
  {
    name: "test___ru",
    path: "/ru/test",
    meta: testcK3hcfoFfRjG44Sytro2zewf_05VUo7OJW_45Q4GspNe8Meta || {},
    component: () => import("/srv/sarvban_front/pages/test.vue")
  },
  {
    name: "test___tr",
    path: "/tr/test",
    meta: testcK3hcfoFfRjG44Sytro2zewf_05VUo7OJW_45Q4GspNe8Meta || {},
    component: () => import("/srv/sarvban_front/pages/test.vue")
  },
  {
    name: "zara___fa",
    path: "/zara",
    meta: zaraX9z_5p_hPQ7eUmmucSCYa5T8RDB6G7iZd7DLQy2wcHEMeta || {},
    component: () => import("/srv/sarvban_front/pages/zara.vue")
  },
  {
    name: "zara___en",
    path: "/en/zara",
    meta: zaraX9z_5p_hPQ7eUmmucSCYa5T8RDB6G7iZd7DLQy2wcHEMeta || {},
    component: () => import("/srv/sarvban_front/pages/zara.vue")
  },
  {
    name: "zara___ar",
    path: "/ar/zara",
    meta: zaraX9z_5p_hPQ7eUmmucSCYa5T8RDB6G7iZd7DLQy2wcHEMeta || {},
    component: () => import("/srv/sarvban_front/pages/zara.vue")
  },
  {
    name: "zara___ru",
    path: "/ru/zara",
    meta: zaraX9z_5p_hPQ7eUmmucSCYa5T8RDB6G7iZd7DLQy2wcHEMeta || {},
    component: () => import("/srv/sarvban_front/pages/zara.vue")
  },
  {
    name: "zara___tr",
    path: "/tr/zara",
    meta: zaraX9z_5p_hPQ7eUmmucSCYa5T8RDB6G7iZd7DLQy2wcHEMeta || {},
    component: () => import("/srv/sarvban_front/pages/zara.vue")
  },
  {
    name: "index___fa",
    path: "/",
    meta: indexAfZPcIGjex36u_45h3_5I1vYFEUqtgel9doKNEiXzYu6sMeta || {},
    component: () => import("/srv/sarvban_front/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexAfZPcIGjex36u_45h3_5I1vYFEUqtgel9doKNEiXzYu6sMeta || {},
    component: () => import("/srv/sarvban_front/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexAfZPcIGjex36u_45h3_5I1vYFEUqtgel9doKNEiXzYu6sMeta || {},
    component: () => import("/srv/sarvban_front/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexAfZPcIGjex36u_45h3_5I1vYFEUqtgel9doKNEiXzYu6sMeta || {},
    component: () => import("/srv/sarvban_front/pages/index.vue")
  },
  {
    name: "index___tr",
    path: "/tr",
    meta: indexAfZPcIGjex36u_45h3_5I1vYFEUqtgel9doKNEiXzYu6sMeta || {},
    component: () => import("/srv/sarvban_front/pages/index.vue")
  },
  {
    name: "login___fa",
    path: "/login",
    meta: loginWU9TCd0o15itMo5byf0_45w7ob6tWae2Hzv3ns33occCsMeta || {},
    component: () => import("/srv/sarvban_front/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginWU9TCd0o15itMo5byf0_45w7ob6tWae2Hzv3ns33occCsMeta || {},
    component: () => import("/srv/sarvban_front/pages/login.vue")
  },
  {
    name: "login___ar",
    path: "/ar/login",
    meta: loginWU9TCd0o15itMo5byf0_45w7ob6tWae2Hzv3ns33occCsMeta || {},
    component: () => import("/srv/sarvban_front/pages/login.vue")
  },
  {
    name: "login___ru",
    path: "/ru/login",
    meta: loginWU9TCd0o15itMo5byf0_45w7ob6tWae2Hzv3ns33occCsMeta || {},
    component: () => import("/srv/sarvban_front/pages/login.vue")
  },
  {
    name: "login___tr",
    path: "/tr/login",
    meta: loginWU9TCd0o15itMo5byf0_45w7ob6tWae2Hzv3ns33occCsMeta || {},
    component: () => import("/srv/sarvban_front/pages/login.vue")
  },
  {
    name: "logout___fa",
    path: "/logout",
    meta: logoutShMXtDZ0AeKbS1PLFmEoJgc_45zW4b6Al5hDFith0_45DpkMeta || {},
    component: () => import("/srv/sarvban_front/pages/logout.vue")
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutShMXtDZ0AeKbS1PLFmEoJgc_45zW4b6Al5hDFith0_45DpkMeta || {},
    component: () => import("/srv/sarvban_front/pages/logout.vue")
  },
  {
    name: "logout___ar",
    path: "/ar/logout",
    meta: logoutShMXtDZ0AeKbS1PLFmEoJgc_45zW4b6Al5hDFith0_45DpkMeta || {},
    component: () => import("/srv/sarvban_front/pages/logout.vue")
  },
  {
    name: "logout___ru",
    path: "/ru/logout",
    meta: logoutShMXtDZ0AeKbS1PLFmEoJgc_45zW4b6Al5hDFith0_45DpkMeta || {},
    component: () => import("/srv/sarvban_front/pages/logout.vue")
  },
  {
    name: "logout___tr",
    path: "/tr/logout",
    meta: logoutShMXtDZ0AeKbS1PLFmEoJgc_45zW4b6Al5hDFith0_45DpkMeta || {},
    component: () => import("/srv/sarvban_front/pages/logout.vue")
  },
  {
    name: "contact___fa",
    path: "/contact",
    meta: contactV0pyyYd0y1jj3qGHW0N_mOwSRG28pLS_45Y2v6gI72YnwMeta || {},
    component: () => import("/srv/sarvban_front/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    meta: contactV0pyyYd0y1jj3qGHW0N_mOwSRG28pLS_45Y2v6gI72YnwMeta || {},
    component: () => import("/srv/sarvban_front/pages/contact.vue")
  },
  {
    name: "contact___ar",
    path: "/ar/contact",
    meta: contactV0pyyYd0y1jj3qGHW0N_mOwSRG28pLS_45Y2v6gI72YnwMeta || {},
    component: () => import("/srv/sarvban_front/pages/contact.vue")
  },
  {
    name: "contact___ru",
    path: "/ru/contact",
    meta: contactV0pyyYd0y1jj3qGHW0N_mOwSRG28pLS_45Y2v6gI72YnwMeta || {},
    component: () => import("/srv/sarvban_front/pages/contact.vue")
  },
  {
    name: "contact___tr",
    path: "/tr/contact",
    meta: contactV0pyyYd0y1jj3qGHW0N_mOwSRG28pLS_45Y2v6gI72YnwMeta || {},
    component: () => import("/srv/sarvban_front/pages/contact.vue")
  },
  {
    name: "landing___fa",
    path: "/landing",
    meta: landingBn_45yLbN9nxfqCbEHbz4fkSe04aRKCJXdhWP4ujShLKEMeta || {},
    component: () => import("/srv/sarvban_front/pages/landing.vue")
  },
  {
    name: "landing___en",
    path: "/en/landing",
    meta: landingBn_45yLbN9nxfqCbEHbz4fkSe04aRKCJXdhWP4ujShLKEMeta || {},
    component: () => import("/srv/sarvban_front/pages/landing.vue")
  },
  {
    name: "landing___ar",
    path: "/ar/landing",
    meta: landingBn_45yLbN9nxfqCbEHbz4fkSe04aRKCJXdhWP4ujShLKEMeta || {},
    component: () => import("/srv/sarvban_front/pages/landing.vue")
  },
  {
    name: "landing___ru",
    path: "/ru/landing",
    meta: landingBn_45yLbN9nxfqCbEHbz4fkSe04aRKCJXdhWP4ujShLKEMeta || {},
    component: () => import("/srv/sarvban_front/pages/landing.vue")
  },
  {
    name: "landing___tr",
    path: "/tr/landing",
    meta: landingBn_45yLbN9nxfqCbEHbz4fkSe04aRKCJXdhWP4ujShLKEMeta || {},
    component: () => import("/srv/sarvban_front/pages/landing.vue")
  },
  {
    name: "pricebp___fa",
    path: "/pricebp",
    meta: pricebptVGvheuwrhxHACFdL2POzHtXBR34FT9AtwQXzJaLm7AMeta || {},
    component: () => import("/srv/sarvban_front/pages/pricebp.vue")
  },
  {
    name: "pricebp___en",
    path: "/en/pricebp",
    meta: pricebptVGvheuwrhxHACFdL2POzHtXBR34FT9AtwQXzJaLm7AMeta || {},
    component: () => import("/srv/sarvban_front/pages/pricebp.vue")
  },
  {
    name: "pricebp___ar",
    path: "/ar/pricebp",
    meta: pricebptVGvheuwrhxHACFdL2POzHtXBR34FT9AtwQXzJaLm7AMeta || {},
    component: () => import("/srv/sarvban_front/pages/pricebp.vue")
  },
  {
    name: "pricebp___ru",
    path: "/ru/pricebp",
    meta: pricebptVGvheuwrhxHACFdL2POzHtXBR34FT9AtwQXzJaLm7AMeta || {},
    component: () => import("/srv/sarvban_front/pages/pricebp.vue")
  },
  {
    name: "pricebp___tr",
    path: "/tr/pricebp",
    meta: pricebptVGvheuwrhxHACFdL2POzHtXBR34FT9AtwQXzJaLm7AMeta || {},
    component: () => import("/srv/sarvban_front/pages/pricebp.vue")
  },
  {
    name: "agriment___fa",
    path: "/agriment",
    meta: agrimentmKDtKSPOllrWeJG8y1yQLHEUSEEAxi7aazswePFWnOYMeta || {},
    component: () => import("/srv/sarvban_front/pages/agriment.vue")
  },
  {
    name: "agriment___en",
    path: "/en/agriment",
    meta: agrimentmKDtKSPOllrWeJG8y1yQLHEUSEEAxi7aazswePFWnOYMeta || {},
    component: () => import("/srv/sarvban_front/pages/agriment.vue")
  },
  {
    name: "agriment___ar",
    path: "/ar/agriment",
    meta: agrimentmKDtKSPOllrWeJG8y1yQLHEUSEEAxi7aazswePFWnOYMeta || {},
    component: () => import("/srv/sarvban_front/pages/agriment.vue")
  },
  {
    name: "agriment___ru",
    path: "/ru/agriment",
    meta: agrimentmKDtKSPOllrWeJG8y1yQLHEUSEEAxi7aazswePFWnOYMeta || {},
    component: () => import("/srv/sarvban_front/pages/agriment.vue")
  },
  {
    name: "agriment___tr",
    path: "/tr/agriment",
    meta: agrimentmKDtKSPOllrWeJG8y1yQLHEUSEEAxi7aazswePFWnOYMeta || {},
    component: () => import("/srv/sarvban_front/pages/agriment.vue")
  },
  {
    name: "homepage___fa",
    path: "/homepage",
    meta: homepageqovwQjsJlY0N_s0BBDDKNx0cIVTWwcxxCLvyy_45yqrIkMeta || {},
    component: () => import("/srv/sarvban_front/pages/homepage.vue")
  },
  {
    name: "homepage___en",
    path: "/en/homepage",
    meta: homepageqovwQjsJlY0N_s0BBDDKNx0cIVTWwcxxCLvyy_45yqrIkMeta || {},
    component: () => import("/srv/sarvban_front/pages/homepage.vue")
  },
  {
    name: "homepage___ar",
    path: "/ar/homepage",
    meta: homepageqovwQjsJlY0N_s0BBDDKNx0cIVTWwcxxCLvyy_45yqrIkMeta || {},
    component: () => import("/srv/sarvban_front/pages/homepage.vue")
  },
  {
    name: "homepage___ru",
    path: "/ru/homepage",
    meta: homepageqovwQjsJlY0N_s0BBDDKNx0cIVTWwcxxCLvyy_45yqrIkMeta || {},
    component: () => import("/srv/sarvban_front/pages/homepage.vue")
  },
  {
    name: "homepage___tr",
    path: "/tr/homepage",
    meta: homepageqovwQjsJlY0N_s0BBDDKNx0cIVTWwcxxCLvyy_45yqrIkMeta || {},
    component: () => import("/srv/sarvban_front/pages/homepage.vue")
  },
  {
    name: "register___fa",
    path: "/register",
    meta: registerJsWs_458P8DGBq4qhxUsY3zxvDVayxV3VFd_45zNAOnF5J0Meta || {},
    component: () => import("/srv/sarvban_front/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registerJsWs_458P8DGBq4qhxUsY3zxvDVayxV3VFd_45zNAOnF5J0Meta || {},
    component: () => import("/srv/sarvban_front/pages/register.vue")
  },
  {
    name: "register___ar",
    path: "/ar/register",
    meta: registerJsWs_458P8DGBq4qhxUsY3zxvDVayxV3VFd_45zNAOnF5J0Meta || {},
    component: () => import("/srv/sarvban_front/pages/register.vue")
  },
  {
    name: "register___ru",
    path: "/ru/register",
    meta: registerJsWs_458P8DGBq4qhxUsY3zxvDVayxV3VFd_45zNAOnF5J0Meta || {},
    component: () => import("/srv/sarvban_front/pages/register.vue")
  },
  {
    name: "register___tr",
    path: "/tr/register",
    meta: registerJsWs_458P8DGBq4qhxUsY3zxvDVayxV3VFd_45zNAOnF5J0Meta || {},
    component: () => import("/srv/sarvban_front/pages/register.vue")
  },
  {
    name: "blog___fa",
    path: "/blog",
    meta: indexXNIFQM2rRMqZYz6H3CraMRo_45gd5bjfeigeYD3bJOtqEMeta || {},
    component: () => import("/srv/sarvban_front/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    meta: indexXNIFQM2rRMqZYz6H3CraMRo_45gd5bjfeigeYD3bJOtqEMeta || {},
    component: () => import("/srv/sarvban_front/pages/blog/index.vue")
  },
  {
    name: "blog___ar",
    path: "/ar/blog",
    meta: indexXNIFQM2rRMqZYz6H3CraMRo_45gd5bjfeigeYD3bJOtqEMeta || {},
    component: () => import("/srv/sarvban_front/pages/blog/index.vue")
  },
  {
    name: "blog___ru",
    path: "/ru/blog",
    meta: indexXNIFQM2rRMqZYz6H3CraMRo_45gd5bjfeigeYD3bJOtqEMeta || {},
    component: () => import("/srv/sarvban_front/pages/blog/index.vue")
  },
  {
    name: "blog___tr",
    path: "/tr/blog",
    meta: indexXNIFQM2rRMqZYz6H3CraMRo_45gd5bjfeigeYD3bJOtqEMeta || {},
    component: () => import("/srv/sarvban_front/pages/blog/index.vue")
  },
  {
    name: "order-id___fa",
    path: "/order/:id()",
    meta: { ...(_91id_93gzx8MdOVJboUwBRVOnNk4xsM4YLbZfC5Mnf3EjfRNoAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/sarvban_front/pages/order/[id].vue")
  },
  {
    name: "order-id___en",
    path: "/en/order/:id()",
    meta: { ...(_91id_93gzx8MdOVJboUwBRVOnNk4xsM4YLbZfC5Mnf3EjfRNoAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/sarvban_front/pages/order/[id].vue")
  },
  {
    name: "order-id___ar",
    path: "/ar/order/:id()",
    meta: { ...(_91id_93gzx8MdOVJboUwBRVOnNk4xsM4YLbZfC5Mnf3EjfRNoAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/sarvban_front/pages/order/[id].vue")
  },
  {
    name: "order-id___ru",
    path: "/ru/order/:id()",
    meta: { ...(_91id_93gzx8MdOVJboUwBRVOnNk4xsM4YLbZfC5Mnf3EjfRNoAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/sarvban_front/pages/order/[id].vue")
  },
  {
    name: "order-id___tr",
    path: "/tr/order/:id()",
    meta: { ...(_91id_93gzx8MdOVJboUwBRVOnNk4xsM4YLbZfC5Mnf3EjfRNoAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/sarvban_front/pages/order/[id].vue")
  },
  {
    name: "blog-slug___fa",
    path: "/blog/:slug()",
    meta: _91slug_93s2VCYhyPmkvpYB_jgaXP_YKg3T8T0KfC9ZZt4Dp6Xn4Meta || {},
    component: () => import("/srv/sarvban_front/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___en",
    path: "/en/blog/:slug()",
    meta: _91slug_93s2VCYhyPmkvpYB_jgaXP_YKg3T8T0KfC9ZZt4Dp6Xn4Meta || {},
    component: () => import("/srv/sarvban_front/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___ar",
    path: "/ar/blog/:slug()",
    meta: _91slug_93s2VCYhyPmkvpYB_jgaXP_YKg3T8T0KfC9ZZt4Dp6Xn4Meta || {},
    component: () => import("/srv/sarvban_front/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___ru",
    path: "/ru/blog/:slug()",
    meta: _91slug_93s2VCYhyPmkvpYB_jgaXP_YKg3T8T0KfC9ZZt4Dp6Xn4Meta || {},
    component: () => import("/srv/sarvban_front/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___tr",
    path: "/tr/blog/:slug()",
    meta: _91slug_93s2VCYhyPmkvpYB_jgaXP_YKg3T8T0KfC9ZZt4Dp6Xn4Meta || {},
    component: () => import("/srv/sarvban_front/pages/blog/[slug].vue")
  },
  {
    name: "details-id___fa",
    path: "/details/:id()",
    meta: _91id_93iLVflF_45Vxb4UT_45R1YOm58110TPCVtP4ST2osQxi8OAgMeta || {},
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-id___en",
    path: "/en/details/:id()",
    meta: _91id_93iLVflF_45Vxb4UT_45R1YOm58110TPCVtP4ST2osQxi8OAgMeta || {},
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-id___ar",
    path: "/ar/details/:id()",
    meta: _91id_93iLVflF_45Vxb4UT_45R1YOm58110TPCVtP4ST2osQxi8OAgMeta || {},
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-id___ru",
    path: "/ru/details/:id()",
    meta: _91id_93iLVflF_45Vxb4UT_45R1YOm58110TPCVtP4ST2osQxi8OAgMeta || {},
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-id___tr",
    path: "/tr/details/:id()",
    meta: _91id_93iLVflF_45Vxb4UT_45R1YOm58110TPCVtP4ST2osQxi8OAgMeta || {},
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "farm-monitor___fa",
    path: "/farm-monitor",
    meta: farm_45monitor2jID9FlzBYE6UE4aHubuYzIIqtrZKoEKZtyxKNsAC0UMeta || {},
    component: () => import("/srv/sarvban_front/pages/farm-monitor.vue")
  },
  {
    name: "farm-monitor___en",
    path: "/en/farm-monitor",
    meta: farm_45monitor2jID9FlzBYE6UE4aHubuYzIIqtrZKoEKZtyxKNsAC0UMeta || {},
    component: () => import("/srv/sarvban_front/pages/farm-monitor.vue")
  },
  {
    name: "farm-monitor___ar",
    path: "/ar/farm-monitor",
    meta: farm_45monitor2jID9FlzBYE6UE4aHubuYzIIqtrZKoEKZtyxKNsAC0UMeta || {},
    component: () => import("/srv/sarvban_front/pages/farm-monitor.vue")
  },
  {
    name: "farm-monitor___ru",
    path: "/ru/farm-monitor",
    meta: farm_45monitor2jID9FlzBYE6UE4aHubuYzIIqtrZKoEKZtyxKNsAC0UMeta || {},
    component: () => import("/srv/sarvban_front/pages/farm-monitor.vue")
  },
  {
    name: "farm-monitor___tr",
    path: "/tr/farm-monitor",
    meta: farm_45monitor2jID9FlzBYE6UE4aHubuYzIIqtrZKoEKZtyxKNsAC0UMeta || {},
    component: () => import("/srv/sarvban_front/pages/farm-monitor.vue")
  },
  {
    name: "invoice-id___fa",
    path: "/invoice/:id()",
    meta: _91id_93WUxyZMAy5GE72p0yddZIAfmOpBZoWCk_ojB4XpVjefkMeta || {},
    component: () => import("/srv/sarvban_front/pages/invoice/[id].vue")
  },
  {
    name: "invoice-id___en",
    path: "/en/invoice/:id()",
    meta: _91id_93WUxyZMAy5GE72p0yddZIAfmOpBZoWCk_ojB4XpVjefkMeta || {},
    component: () => import("/srv/sarvban_front/pages/invoice/[id].vue")
  },
  {
    name: "invoice-id___ar",
    path: "/ar/invoice/:id()",
    meta: _91id_93WUxyZMAy5GE72p0yddZIAfmOpBZoWCk_ojB4XpVjefkMeta || {},
    component: () => import("/srv/sarvban_front/pages/invoice/[id].vue")
  },
  {
    name: "invoice-id___ru",
    path: "/ru/invoice/:id()",
    meta: _91id_93WUxyZMAy5GE72p0yddZIAfmOpBZoWCk_ojB4XpVjefkMeta || {},
    component: () => import("/srv/sarvban_front/pages/invoice/[id].vue")
  },
  {
    name: "invoice-id___tr",
    path: "/tr/invoice/:id()",
    meta: _91id_93WUxyZMAy5GE72p0yddZIAfmOpBZoWCk_ojB4XpVjefkMeta || {},
    component: () => import("/srv/sarvban_front/pages/invoice/[id].vue")
  },
  {
    name: "search-key___fa",
    path: "/search/:key()",
    meta: _91key_93UVTwaEjlBkNcr02Kk1OVA6NWxCuWhEBZ9vixqZx7T0gMeta || {},
    component: () => import("/srv/sarvban_front/pages/search/[key].vue")
  },
  {
    name: "search-key___en",
    path: "/en/search/:key()",
    meta: _91key_93UVTwaEjlBkNcr02Kk1OVA6NWxCuWhEBZ9vixqZx7T0gMeta || {},
    component: () => import("/srv/sarvban_front/pages/search/[key].vue")
  },
  {
    name: "search-key___ar",
    path: "/ar/search/:key()",
    meta: _91key_93UVTwaEjlBkNcr02Kk1OVA6NWxCuWhEBZ9vixqZx7T0gMeta || {},
    component: () => import("/srv/sarvban_front/pages/search/[key].vue")
  },
  {
    name: "search-key___ru",
    path: "/ru/search/:key()",
    meta: _91key_93UVTwaEjlBkNcr02Kk1OVA6NWxCuWhEBZ9vixqZx7T0gMeta || {},
    component: () => import("/srv/sarvban_front/pages/search/[key].vue")
  },
  {
    name: "search-key___tr",
    path: "/tr/search/:key()",
    meta: _91key_93UVTwaEjlBkNcr02Kk1OVA6NWxCuWhEBZ9vixqZx7T0gMeta || {},
    component: () => import("/srv/sarvban_front/pages/search/[key].vue")
  },
  {
    name: "about-sarvban___fa",
    path: "/about-sarvban",
    component: () => import("/srv/sarvban_front/pages/about-sarvban.vue")
  },
  {
    name: "about-sarvban___en",
    path: "/en/about-sarvban",
    component: () => import("/srv/sarvban_front/pages/about-sarvban.vue")
  },
  {
    name: "about-sarvban___ar",
    path: "/ar/about-sarvban",
    component: () => import("/srv/sarvban_front/pages/about-sarvban.vue")
  },
  {
    name: "about-sarvban___ru",
    path: "/ru/about-sarvban",
    component: () => import("/srv/sarvban_front/pages/about-sarvban.vue")
  },
  {
    name: "about-sarvban___tr",
    path: "/tr/about-sarvban",
    component: () => import("/srv/sarvban_front/pages/about-sarvban.vue")
  },
  {
    name: "add-ads___fa",
    path: "/add-ads",
    meta: { ...(indext2S1_45x3JXJT_45G5MKOn6C9IuhWsLG0sMAtuRsgqkvWmgMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ads/index.vue")
  },
  {
    name: "add-ads___en",
    path: "/en/add-ads",
    meta: { ...(indext2S1_45x3JXJT_45G5MKOn6C9IuhWsLG0sMAtuRsgqkvWmgMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ads/index.vue")
  },
  {
    name: "add-ads___ar",
    path: "/ar/add-ads",
    meta: { ...(indext2S1_45x3JXJT_45G5MKOn6C9IuhWsLG0sMAtuRsgqkvWmgMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ads/index.vue")
  },
  {
    name: "add-ads___ru",
    path: "/ru/add-ads",
    meta: { ...(indext2S1_45x3JXJT_45G5MKOn6C9IuhWsLG0sMAtuRsgqkvWmgMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ads/index.vue")
  },
  {
    name: "add-ads___tr",
    path: "/tr/add-ads",
    meta: { ...(indext2S1_45x3JXJT_45G5MKOn6C9IuhWsLG0sMAtuRsgqkvWmgMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ads/index.vue")
  },
  {
    name: "add-adv___fa",
    path: "/add-adv",
    meta: { ...(index1tQtfJ_45YDBmtfRVtKnWoa9kxkJrZnO0Gjxo2ndqAnYoMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-adv/index.vue")
  },
  {
    name: "add-adv___en",
    path: "/en/add-adv",
    meta: { ...(index1tQtfJ_45YDBmtfRVtKnWoa9kxkJrZnO0Gjxo2ndqAnYoMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-adv/index.vue")
  },
  {
    name: "add-adv___ar",
    path: "/ar/add-adv",
    meta: { ...(index1tQtfJ_45YDBmtfRVtKnWoa9kxkJrZnO0Gjxo2ndqAnYoMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-adv/index.vue")
  },
  {
    name: "add-adv___ru",
    path: "/ru/add-adv",
    meta: { ...(index1tQtfJ_45YDBmtfRVtKnWoa9kxkJrZnO0Gjxo2ndqAnYoMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-adv/index.vue")
  },
  {
    name: "add-adv___tr",
    path: "/tr/add-adv",
    meta: { ...(index1tQtfJ_45YDBmtfRVtKnWoa9kxkJrZnO0Gjxo2ndqAnYoMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-adv/index.vue")
  },
  {
    name: "add-ord___fa",
    path: "/add-ord",
    meta: { ...(indexx231sfLaiIvoyuClKUf0irULWcGAxmjbpKJmeCyLHB0Meta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ord/index.vue")
  },
  {
    name: "add-ord___en",
    path: "/en/add-ord",
    meta: { ...(indexx231sfLaiIvoyuClKUf0irULWcGAxmjbpKJmeCyLHB0Meta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ord/index.vue")
  },
  {
    name: "add-ord___ar",
    path: "/ar/add-ord",
    meta: { ...(indexx231sfLaiIvoyuClKUf0irULWcGAxmjbpKJmeCyLHB0Meta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ord/index.vue")
  },
  {
    name: "add-ord___ru",
    path: "/ru/add-ord",
    meta: { ...(indexx231sfLaiIvoyuClKUf0irULWcGAxmjbpKJmeCyLHB0Meta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ord/index.vue")
  },
  {
    name: "add-ord___tr",
    path: "/tr/add-ord",
    meta: { ...(indexx231sfLaiIvoyuClKUf0irULWcGAxmjbpKJmeCyLHB0Meta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ord/index.vue")
  },
  {
    name: "test-contract___fa",
    path: "/test-contract",
    meta: test_45contractg287Eq06cW2xxVCDHfKv2BC8GI42ezndGThyDwY3mJUMeta || {},
    component: () => import("/srv/sarvban_front/pages/test-contract.vue")
  },
  {
    name: "test-contract___en",
    path: "/en/test-contract",
    meta: test_45contractg287Eq06cW2xxVCDHfKv2BC8GI42ezndGThyDwY3mJUMeta || {},
    component: () => import("/srv/sarvban_front/pages/test-contract.vue")
  },
  {
    name: "test-contract___ar",
    path: "/ar/test-contract",
    meta: test_45contractg287Eq06cW2xxVCDHfKv2BC8GI42ezndGThyDwY3mJUMeta || {},
    component: () => import("/srv/sarvban_front/pages/test-contract.vue")
  },
  {
    name: "test-contract___ru",
    path: "/ru/test-contract",
    meta: test_45contractg287Eq06cW2xxVCDHfKv2BC8GI42ezndGThyDwY3mJUMeta || {},
    component: () => import("/srv/sarvban_front/pages/test-contract.vue")
  },
  {
    name: "test-contract___tr",
    path: "/tr/test-contract",
    meta: test_45contractg287Eq06cW2xxVCDHfKv2BC8GI42ezndGThyDwY3mJUMeta || {},
    component: () => import("/srv/sarvban_front/pages/test-contract.vue")
  },
  {
    name: "about-services___fa",
    path: "/about-services",
    component: () => import("/srv/sarvban_front/pages/about-services.vue")
  },
  {
    name: "about-services___en",
    path: "/en/about-services",
    component: () => import("/srv/sarvban_front/pages/about-services.vue")
  },
  {
    name: "about-services___ar",
    path: "/ar/about-services",
    component: () => import("/srv/sarvban_front/pages/about-services.vue")
  },
  {
    name: "about-services___ru",
    path: "/ru/about-services",
    component: () => import("/srv/sarvban_front/pages/about-services.vue")
  },
  {
    name: "about-services___tr",
    path: "/tr/about-services",
    component: () => import("/srv/sarvban_front/pages/about-services.vue")
  },
  {
    name: "payment-verify___fa",
    path: "/payment/verify",
    component: () => import("/srv/sarvban_front/pages/payment/verify.vue")
  },
  {
    name: "payment-verify___en",
    path: "/en/payment/verify",
    component: () => import("/srv/sarvban_front/pages/payment/verify.vue")
  },
  {
    name: "payment-verify___ar",
    path: "/ar/payment/verify",
    component: () => import("/srv/sarvban_front/pages/payment/verify.vue")
  },
  {
    name: "payment-verify___ru",
    path: "/ru/payment/verify",
    component: () => import("/srv/sarvban_front/pages/payment/verify.vue")
  },
  {
    name: "payment-verify___tr",
    path: "/tr/payment/verify",
    component: () => import("/srv/sarvban_front/pages/payment/verify.vue")
  },
  {
    name: "products___fa",
    path: "/products",
    meta: indexW7rgoRbuIGuvnE1r49B8BvLcOysFNrEDlYqoM0aw1BgMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products___en",
    path: "/en/products",
    meta: indexW7rgoRbuIGuvnE1r49B8BvLcOysFNrEDlYqoM0aw1BgMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products___ar",
    path: "/ar/products",
    meta: indexW7rgoRbuIGuvnE1r49B8BvLcOysFNrEDlYqoM0aw1BgMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products___ru",
    path: "/ru/products",
    meta: indexW7rgoRbuIGuvnE1r49B8BvLcOysFNrEDlYqoM0aw1BgMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products___tr",
    path: "/tr/products",
    meta: indexW7rgoRbuIGuvnE1r49B8BvLcOysFNrEDlYqoM0aw1BgMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "payment-invoice___fa",
    path: "/payment/invoice",
    meta: invoicePT3eqYnaGKM9TcNAzWI_X2K3FOvMcUoebqS8XVzrQnEMeta || {},
    component: () => import("/srv/sarvban_front/pages/payment/invoice.vue")
  },
  {
    name: "payment-invoice___en",
    path: "/en/payment/invoice",
    meta: invoicePT3eqYnaGKM9TcNAzWI_X2K3FOvMcUoebqS8XVzrQnEMeta || {},
    component: () => import("/srv/sarvban_front/pages/payment/invoice.vue")
  },
  {
    name: "payment-invoice___ar",
    path: "/ar/payment/invoice",
    meta: invoicePT3eqYnaGKM9TcNAzWI_X2K3FOvMcUoebqS8XVzrQnEMeta || {},
    component: () => import("/srv/sarvban_front/pages/payment/invoice.vue")
  },
  {
    name: "payment-invoice___ru",
    path: "/ru/payment/invoice",
    meta: invoicePT3eqYnaGKM9TcNAzWI_X2K3FOvMcUoebqS8XVzrQnEMeta || {},
    component: () => import("/srv/sarvban_front/pages/payment/invoice.vue")
  },
  {
    name: "payment-invoice___tr",
    path: "/tr/payment/invoice",
    meta: invoicePT3eqYnaGKM9TcNAzWI_X2K3FOvMcUoebqS8XVzrQnEMeta || {},
    component: () => import("/srv/sarvban_front/pages/payment/invoice.vue")
  },
  {
    name: "products-seller___fa",
    path: "/products/seller",
    meta: seller7mDZGNb68BwoGj7wm_Xq7xFzur8Dv04FR2zZkX5ktHUMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/seller.vue")
  },
  {
    name: "products-seller___en",
    path: "/en/products/seller",
    meta: seller7mDZGNb68BwoGj7wm_Xq7xFzur8Dv04FR2zZkX5ktHUMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/seller.vue")
  },
  {
    name: "products-seller___ar",
    path: "/ar/products/seller",
    meta: seller7mDZGNb68BwoGj7wm_Xq7xFzur8Dv04FR2zZkX5ktHUMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/seller.vue")
  },
  {
    name: "products-seller___ru",
    path: "/ru/products/seller",
    meta: seller7mDZGNb68BwoGj7wm_Xq7xFzur8Dv04FR2zZkX5ktHUMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/seller.vue")
  },
  {
    name: "products-seller___tr",
    path: "/tr/products/seller",
    meta: seller7mDZGNb68BwoGj7wm_Xq7xFzur8Dv04FR2zZkX5ktHUMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/seller.vue")
  },
  {
    name: "contract-builder___fa",
    path: "/contract-builder",
    meta: contract_45builderNKd1j1euOn0EtrItZsRSxrle5h_D87UhYiNgyZppb1wMeta || {},
    component: () => import("/srv/sarvban_front/pages/contract-builder.vue")
  },
  {
    name: "contract-builder___en",
    path: "/en/contract-builder",
    meta: contract_45builderNKd1j1euOn0EtrItZsRSxrle5h_D87UhYiNgyZppb1wMeta || {},
    component: () => import("/srv/sarvban_front/pages/contract-builder.vue")
  },
  {
    name: "contract-builder___ar",
    path: "/ar/contract-builder",
    meta: contract_45builderNKd1j1euOn0EtrItZsRSxrle5h_D87UhYiNgyZppb1wMeta || {},
    component: () => import("/srv/sarvban_front/pages/contract-builder.vue")
  },
  {
    name: "contract-builder___ru",
    path: "/ru/contract-builder",
    meta: contract_45builderNKd1j1euOn0EtrItZsRSxrle5h_D87UhYiNgyZppb1wMeta || {},
    component: () => import("/srv/sarvban_front/pages/contract-builder.vue")
  },
  {
    name: "contract-builder___tr",
    path: "/tr/contract-builder",
    meta: contract_45builderNKd1j1euOn0EtrItZsRSxrle5h_D87UhYiNgyZppb1wMeta || {},
    component: () => import("/srv/sarvban_front/pages/contract-builder.vue")
  },
  {
    name: "my-sarvban___fa",
    path: "/my-sarvban",
    meta: { ...(index0yGb_45CXKJTn_45kUv8nHCImohOqLiiN1ldcchtU4SjMNgMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/index.vue")
  },
  {
    name: "my-sarvban___en",
    path: "/en/my-sarvban",
    meta: { ...(index0yGb_45CXKJTn_45kUv8nHCImohOqLiiN1ldcchtU4SjMNgMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/index.vue")
  },
  {
    name: "my-sarvban___ar",
    path: "/ar/my-sarvban",
    meta: { ...(index0yGb_45CXKJTn_45kUv8nHCImohOqLiiN1ldcchtU4SjMNgMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/index.vue")
  },
  {
    name: "my-sarvban___ru",
    path: "/ru/my-sarvban",
    meta: { ...(index0yGb_45CXKJTn_45kUv8nHCImohOqLiiN1ldcchtU4SjMNgMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/index.vue")
  },
  {
    name: "my-sarvban___tr",
    path: "/tr/my-sarvban",
    meta: { ...(index0yGb_45CXKJTn_45kUv8nHCImohOqLiiN1ldcchtU4SjMNgMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/index.vue")
  },
  {
    name: "my-sarvban-orders___fa",
    path: "/my-sarvban/orders",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/orders.vue")
  },
  {
    name: "my-sarvban-orders___en",
    path: "/en/my-sarvban/orders",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/orders.vue")
  },
  {
    name: "my-sarvban-orders___ar",
    path: "/ar/my-sarvban/orders",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/orders.vue")
  },
  {
    name: "my-sarvban-orders___ru",
    path: "/ru/my-sarvban/orders",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/orders.vue")
  },
  {
    name: "my-sarvban-orders___tr",
    path: "/tr/my-sarvban/orders",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/orders.vue")
  },
  {
    name: "my-sarvban-wallet___fa",
    path: "/my-sarvban/wallet",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/wallet.vue")
  },
  {
    name: "my-sarvban-wallet___en",
    path: "/en/my-sarvban/wallet",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/wallet.vue")
  },
  {
    name: "my-sarvban-wallet___ar",
    path: "/ar/my-sarvban/wallet",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/wallet.vue")
  },
  {
    name: "my-sarvban-wallet___ru",
    path: "/ru/my-sarvban/wallet",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/wallet.vue")
  },
  {
    name: "my-sarvban-wallet___tr",
    path: "/tr/my-sarvban/wallet",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/wallet.vue")
  },
  {
    name: "products-services___fa",
    path: "/products/services",
    meta: servicesC6qcNSEXa_PtWXwjtzdAlEZe0NW5LdNuQp77e0r41D8Meta || {},
    component: () => import("/srv/sarvban_front/pages/products/services.vue")
  },
  {
    name: "products-services___en",
    path: "/en/products/services",
    meta: servicesC6qcNSEXa_PtWXwjtzdAlEZe0NW5LdNuQp77e0r41D8Meta || {},
    component: () => import("/srv/sarvban_front/pages/products/services.vue")
  },
  {
    name: "products-services___ar",
    path: "/ar/products/services",
    meta: servicesC6qcNSEXa_PtWXwjtzdAlEZe0NW5LdNuQp77e0r41D8Meta || {},
    component: () => import("/srv/sarvban_front/pages/products/services.vue")
  },
  {
    name: "products-services___ru",
    path: "/ru/products/services",
    meta: servicesC6qcNSEXa_PtWXwjtzdAlEZe0NW5LdNuQp77e0r41D8Meta || {},
    component: () => import("/srv/sarvban_front/pages/products/services.vue")
  },
  {
    name: "products-services___tr",
    path: "/tr/products/services",
    meta: servicesC6qcNSEXa_PtWXwjtzdAlEZe0NW5LdNuQp77e0r41D8Meta || {},
    component: () => import("/srv/sarvban_front/pages/products/services.vue")
  },
  {
    name: "region-bar-city___fa",
    path: "/region/bar/:city()",
    meta: _91city_937u1LMp_hw6TiCcvKxsQWfPNBrj2IFn5Z4fmN_hWk3fAMeta || {},
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "region-bar-city___en",
    path: "/en/region/bar/:city()",
    meta: _91city_937u1LMp_hw6TiCcvKxsQWfPNBrj2IFn5Z4fmN_hWk3fAMeta || {},
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "region-bar-city___ar",
    path: "/ar/region/bar/:city()",
    meta: _91city_937u1LMp_hw6TiCcvKxsQWfPNBrj2IFn5Z4fmN_hWk3fAMeta || {},
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "region-bar-city___ru",
    path: "/ru/region/bar/:city()",
    meta: _91city_937u1LMp_hw6TiCcvKxsQWfPNBrj2IFn5Z4fmN_hWk3fAMeta || {},
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "region-bar-city___tr",
    path: "/tr/region/bar/:city()",
    meta: _91city_937u1LMp_hw6TiCcvKxsQWfPNBrj2IFn5Z4fmN_hWk3fAMeta || {},
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "add-ads-edit___fa",
    path: "/add-ads/edit",
    meta: { ...(index_U8zR9ztaewW_45A21u3mN4V8czgJG2xHsqQ2iF3TZecIMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ads/edit/index.vue")
  },
  {
    name: "add-ads-edit___en",
    path: "/en/add-ads/edit",
    meta: { ...(index_U8zR9ztaewW_45A21u3mN4V8czgJG2xHsqQ2iF3TZecIMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ads/edit/index.vue")
  },
  {
    name: "add-ads-edit___ar",
    path: "/ar/add-ads/edit",
    meta: { ...(index_U8zR9ztaewW_45A21u3mN4V8czgJG2xHsqQ2iF3TZecIMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ads/edit/index.vue")
  },
  {
    name: "add-ads-edit___ru",
    path: "/ru/add-ads/edit",
    meta: { ...(index_U8zR9ztaewW_45A21u3mN4V8czgJG2xHsqQ2iF3TZecIMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ads/edit/index.vue")
  },
  {
    name: "add-ads-edit___tr",
    path: "/tr/add-ads/edit",
    meta: { ...(index_U8zR9ztaewW_45A21u3mN4V8czgJG2xHsqQ2iF3TZecIMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-ads/edit/index.vue")
  },
  {
    name: "add-adv-edit___fa",
    path: "/add-adv/edit",
    meta: { ...(indexD6lGfNkBxFetr7Y7y_45WlIQ_GY3weqQFBftaVqd_BEocMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-adv/edit/index.vue")
  },
  {
    name: "add-adv-edit___en",
    path: "/en/add-adv/edit",
    meta: { ...(indexD6lGfNkBxFetr7Y7y_45WlIQ_GY3weqQFBftaVqd_BEocMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-adv/edit/index.vue")
  },
  {
    name: "add-adv-edit___ar",
    path: "/ar/add-adv/edit",
    meta: { ...(indexD6lGfNkBxFetr7Y7y_45WlIQ_GY3weqQFBftaVqd_BEocMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-adv/edit/index.vue")
  },
  {
    name: "add-adv-edit___ru",
    path: "/ru/add-adv/edit",
    meta: { ...(indexD6lGfNkBxFetr7Y7y_45WlIQ_GY3weqQFBftaVqd_BEocMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-adv/edit/index.vue")
  },
  {
    name: "add-adv-edit___tr",
    path: "/tr/add-adv/edit",
    meta: { ...(indexD6lGfNkBxFetr7Y7y_45WlIQ_GY3weqQFBftaVqd_BEocMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/add-adv/edit/index.vue")
  },
  {
    name: "my-sarvban-profile___fa",
    path: "/my-sarvban/profile",
    meta: { ...(profilefFn307o26DIiGZzTsLX56Be_45pMnIy0tW9VKFm1X_45iAMMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/profile.vue")
  },
  {
    name: "my-sarvban-profile___en",
    path: "/en/my-sarvban/profile",
    meta: { ...(profilefFn307o26DIiGZzTsLX56Be_45pMnIy0tW9VKFm1X_45iAMMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/profile.vue")
  },
  {
    name: "my-sarvban-profile___ar",
    path: "/ar/my-sarvban/profile",
    meta: { ...(profilefFn307o26DIiGZzTsLX56Be_45pMnIy0tW9VKFm1X_45iAMMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/profile.vue")
  },
  {
    name: "my-sarvban-profile___ru",
    path: "/ru/my-sarvban/profile",
    meta: { ...(profilefFn307o26DIiGZzTsLX56Be_45pMnIy0tW9VKFm1X_45iAMMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/profile.vue")
  },
  {
    name: "my-sarvban-profile___tr",
    path: "/tr/my-sarvban/profile",
    meta: { ...(profilefFn307o26DIiGZzTsLX56Be_45pMnIy0tW9VKFm1X_45iAMMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/profile.vue")
  },
  {
    name: "my-sarvban-related___fa",
    path: "/my-sarvban/related",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/related.vue")
  },
  {
    name: "my-sarvban-related___en",
    path: "/en/my-sarvban/related",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/related.vue")
  },
  {
    name: "my-sarvban-related___ar",
    path: "/ar/my-sarvban/related",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/related.vue")
  },
  {
    name: "my-sarvban-related___ru",
    path: "/ru/my-sarvban/related",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/related.vue")
  },
  {
    name: "my-sarvban-related___tr",
    path: "/tr/my-sarvban/related",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/related.vue")
  },
  {
    name: "region-amayesh-son___fa",
    path: "/region/amayesh/son",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/son.vue")
  },
  {
    name: "region-amayesh-son___en",
    path: "/en/region/amayesh/son",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/son.vue")
  },
  {
    name: "region-amayesh-son___ar",
    path: "/ar/region/amayesh/son",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/son.vue")
  },
  {
    name: "region-amayesh-son___ru",
    path: "/ru/region/amayesh/son",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/son.vue")
  },
  {
    name: "region-amayesh-son___tr",
    path: "/tr/region/amayesh/son",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/son.vue")
  },
  {
    name: "my-sarvban-messages___fa",
    path: "/my-sarvban/messages",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/messages.vue")
  },
  {
    name: "my-sarvban-messages___en",
    path: "/en/my-sarvban/messages",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/messages.vue")
  },
  {
    name: "my-sarvban-messages___ar",
    path: "/ar/my-sarvban/messages",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/messages.vue")
  },
  {
    name: "my-sarvban-messages___ru",
    path: "/ru/my-sarvban/messages",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/messages.vue")
  },
  {
    name: "my-sarvban-messages___tr",
    path: "/tr/my-sarvban/messages",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/messages.vue")
  },
  {
    name: "my-sarvban-services___fa",
    path: "/my-sarvban/services",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/services.vue")
  },
  {
    name: "my-sarvban-services___en",
    path: "/en/my-sarvban/services",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/services.vue")
  },
  {
    name: "my-sarvban-services___ar",
    path: "/ar/my-sarvban/services",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/services.vue")
  },
  {
    name: "my-sarvban-services___ru",
    path: "/ru/my-sarvban/services",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/services.vue")
  },
  {
    name: "my-sarvban-services___tr",
    path: "/tr/my-sarvban/services",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/services.vue")
  },
  {
    name: "payment-verify-test___fa",
    path: "/payment/verify-test",
    component: () => import("/srv/sarvban_front/pages/payment/verify-test.vue")
  },
  {
    name: "payment-verify-test___en",
    path: "/en/payment/verify-test",
    component: () => import("/srv/sarvban_front/pages/payment/verify-test.vue")
  },
  {
    name: "payment-verify-test___ar",
    path: "/ar/payment/verify-test",
    component: () => import("/srv/sarvban_front/pages/payment/verify-test.vue")
  },
  {
    name: "payment-verify-test___ru",
    path: "/ru/payment/verify-test",
    component: () => import("/srv/sarvban_front/pages/payment/verify-test.vue")
  },
  {
    name: "payment-verify-test___tr",
    path: "/tr/payment/verify-test",
    component: () => import("/srv/sarvban_front/pages/payment/verify-test.vue")
  },
  {
    name: "blog-category-slug___fa",
    path: "/blog/category/:slug()",
    meta: _91slug_934rK6E2t3wEfCoaJZp0bss9_45NraYoH3hLlB9sSVDEnd4Meta || {},
    component: () => import("/srv/sarvban_front/pages/blog/category/[slug].vue")
  },
  {
    name: "blog-category-slug___en",
    path: "/en/blog/category/:slug()",
    meta: _91slug_934rK6E2t3wEfCoaJZp0bss9_45NraYoH3hLlB9sSVDEnd4Meta || {},
    component: () => import("/srv/sarvban_front/pages/blog/category/[slug].vue")
  },
  {
    name: "blog-category-slug___ar",
    path: "/ar/blog/category/:slug()",
    meta: _91slug_934rK6E2t3wEfCoaJZp0bss9_45NraYoH3hLlB9sSVDEnd4Meta || {},
    component: () => import("/srv/sarvban_front/pages/blog/category/[slug].vue")
  },
  {
    name: "blog-category-slug___ru",
    path: "/ru/blog/category/:slug()",
    meta: _91slug_934rK6E2t3wEfCoaJZp0bss9_45NraYoH3hLlB9sSVDEnd4Meta || {},
    component: () => import("/srv/sarvban_front/pages/blog/category/[slug].vue")
  },
  {
    name: "blog-category-slug___tr",
    path: "/tr/blog/category/:slug()",
    meta: _91slug_934rK6E2t3wEfCoaJZp0bss9_45NraYoH3hLlB9sSVDEnd4Meta || {},
    component: () => import("/srv/sarvban_front/pages/blog/category/[slug].vue")
  },
  {
    name: "my-sarvban-adv___fa",
    path: "/my-sarvban/adv",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/index.vue")
  },
  {
    name: "my-sarvban-adv___en",
    path: "/en/my-sarvban/adv",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/index.vue")
  },
  {
    name: "my-sarvban-adv___ar",
    path: "/ar/my-sarvban/adv",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/index.vue")
  },
  {
    name: "my-sarvban-adv___ru",
    path: "/ru/my-sarvban/adv",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/index.vue")
  },
  {
    name: "my-sarvban-adv___tr",
    path: "/tr/my-sarvban/adv",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/index.vue")
  },
  {
    name: "region-amayesh___fa",
    path: "/region/amayesh",
    meta: index41JDNsTjhTnzC3TRQFlWSp1OxRwri8hjmg_45aVdDK86cMeta || {},
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "region-amayesh___en",
    path: "/en/region/amayesh",
    meta: index41JDNsTjhTnzC3TRQFlWSp1OxRwri8hjmg_45aVdDK86cMeta || {},
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "region-amayesh___ar",
    path: "/ar/region/amayesh",
    meta: index41JDNsTjhTnzC3TRQFlWSp1OxRwri8hjmg_45aVdDK86cMeta || {},
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "region-amayesh___ru",
    path: "/ru/region/amayesh",
    meta: index41JDNsTjhTnzC3TRQFlWSp1OxRwri8hjmg_45aVdDK86cMeta || {},
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "region-amayesh___tr",
    path: "/tr/region/amayesh",
    meta: index41JDNsTjhTnzC3TRQFlWSp1OxRwri8hjmg_45aVdDK86cMeta || {},
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "region-amayesh-zchat___fa",
    path: "/region/amayesh/zchat",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/zchat.vue")
  },
  {
    name: "region-amayesh-zchat___en",
    path: "/en/region/amayesh/zchat",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/zchat.vue")
  },
  {
    name: "region-amayesh-zchat___ar",
    path: "/ar/region/amayesh/zchat",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/zchat.vue")
  },
  {
    name: "region-amayesh-zchat___ru",
    path: "/ru/region/amayesh/zchat",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/zchat.vue")
  },
  {
    name: "region-amayesh-zchat___tr",
    path: "/tr/region/amayesh/zchat",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/zchat.vue")
  },
  {
    name: "my-sarvban-price-bids___fa",
    path: "/my-sarvban/price-bids",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/price-bids.vue")
  },
  {
    name: "my-sarvban-price-bids___en",
    path: "/en/my-sarvban/price-bids",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/price-bids.vue")
  },
  {
    name: "my-sarvban-price-bids___ar",
    path: "/ar/my-sarvban/price-bids",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/price-bids.vue")
  },
  {
    name: "my-sarvban-price-bids___ru",
    path: "/ru/my-sarvban/price-bids",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/price-bids.vue")
  },
  {
    name: "my-sarvban-price-bids___tr",
    path: "/tr/my-sarvban/price-bids",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/price-bids.vue")
  },
  {
    name: "products-outofseasion___fa",
    path: "/products/outofseasion",
    meta: outofseasionIk909H6mz1QUFSDynGwyW40tRsORwNYF_45gh78lP3txkMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/outofseasion.vue")
  },
  {
    name: "products-outofseasion___en",
    path: "/en/products/outofseasion",
    meta: outofseasionIk909H6mz1QUFSDynGwyW40tRsORwNYF_45gh78lP3txkMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/outofseasion.vue")
  },
  {
    name: "products-outofseasion___ar",
    path: "/ar/products/outofseasion",
    meta: outofseasionIk909H6mz1QUFSDynGwyW40tRsORwNYF_45gh78lP3txkMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/outofseasion.vue")
  },
  {
    name: "products-outofseasion___ru",
    path: "/ru/products/outofseasion",
    meta: outofseasionIk909H6mz1QUFSDynGwyW40tRsORwNYF_45gh78lP3txkMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/outofseasion.vue")
  },
  {
    name: "products-outofseasion___tr",
    path: "/tr/products/outofseasion",
    meta: outofseasionIk909H6mz1QUFSDynGwyW40tRsORwNYF_45gh78lP3txkMeta || {},
    component: () => import("/srv/sarvban_front/pages/products/outofseasion.vue")
  },
  {
    name: "my-sarvban-buyers-list___fa",
    path: "/my-sarvban/buyers-list",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buyers-list.vue")
  },
  {
    name: "my-sarvban-buyers-list___en",
    path: "/en/my-sarvban/buyers-list",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buyers-list.vue")
  },
  {
    name: "my-sarvban-buyers-list___ar",
    path: "/ar/my-sarvban/buyers-list",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buyers-list.vue")
  },
  {
    name: "my-sarvban-buyers-list___ru",
    path: "/ru/my-sarvban/buyers-list",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buyers-list.vue")
  },
  {
    name: "my-sarvban-buyers-list___tr",
    path: "/tr/my-sarvban/buyers-list",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buyers-list.vue")
  },
  {
    name: "my-sarvban-number-list___fa",
    path: "/my-sarvban/number-list",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/number-list.vue")
  },
  {
    name: "my-sarvban-number-list___en",
    path: "/en/my-sarvban/number-list",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/number-list.vue")
  },
  {
    name: "my-sarvban-number-list___ar",
    path: "/ar/my-sarvban/number-list",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/number-list.vue")
  },
  {
    name: "my-sarvban-number-list___ru",
    path: "/ru/my-sarvban/number-list",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/number-list.vue")
  },
  {
    name: "my-sarvban-number-list___tr",
    path: "/tr/my-sarvban/number-list",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/number-list.vue")
  },
  {
    name: "my-sarvban-adv-edit-id___fa",
    path: "/my-sarvban/adv/edit/:id()",
    meta: { ...(_91id_93sSeCV_45y1jNlbuQ5UoCBUFVxmKem8tbstLBxCuJIcgpIMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/edit/[id].vue")
  },
  {
    name: "my-sarvban-adv-edit-id___en",
    path: "/en/my-sarvban/adv/edit/:id()",
    meta: { ...(_91id_93sSeCV_45y1jNlbuQ5UoCBUFVxmKem8tbstLBxCuJIcgpIMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/edit/[id].vue")
  },
  {
    name: "my-sarvban-adv-edit-id___ar",
    path: "/ar/my-sarvban/adv/edit/:id()",
    meta: { ...(_91id_93sSeCV_45y1jNlbuQ5UoCBUFVxmKem8tbstLBxCuJIcgpIMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/edit/[id].vue")
  },
  {
    name: "my-sarvban-adv-edit-id___ru",
    path: "/ru/my-sarvban/adv/edit/:id()",
    meta: { ...(_91id_93sSeCV_45y1jNlbuQ5UoCBUFVxmKem8tbstLBxCuJIcgpIMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/edit/[id].vue")
  },
  {
    name: "my-sarvban-adv-edit-id___tr",
    path: "/tr/my-sarvban/adv/edit/:id()",
    meta: { ...(_91id_93sSeCV_45y1jNlbuQ5UoCBUFVxmKem8tbstLBxCuJIcgpIMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/edit/[id].vue")
  },
  {
    name: "my-sarvban-broadcast-ord-id___fa",
    path: "/my-sarvban/broadcast-ord/:id()",
    meta: { ...(_91id_93ac_KhBwG9LR6d7RCqRmdY1S4v5VLtPTVinZmFBkFUK8Meta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/[id].vue")
  },
  {
    name: "my-sarvban-broadcast-ord-id___en",
    path: "/en/my-sarvban/broadcast-ord/:id()",
    meta: { ...(_91id_93ac_KhBwG9LR6d7RCqRmdY1S4v5VLtPTVinZmFBkFUK8Meta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/[id].vue")
  },
  {
    name: "my-sarvban-broadcast-ord-id___ar",
    path: "/ar/my-sarvban/broadcast-ord/:id()",
    meta: { ...(_91id_93ac_KhBwG9LR6d7RCqRmdY1S4v5VLtPTVinZmFBkFUK8Meta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/[id].vue")
  },
  {
    name: "my-sarvban-broadcast-ord-id___ru",
    path: "/ru/my-sarvban/broadcast-ord/:id()",
    meta: { ...(_91id_93ac_KhBwG9LR6d7RCqRmdY1S4v5VLtPTVinZmFBkFUK8Meta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/[id].vue")
  },
  {
    name: "my-sarvban-broadcast-ord-id___tr",
    path: "/tr/my-sarvban/broadcast-ord/:id()",
    meta: { ...(_91id_93ac_KhBwG9LR6d7RCqRmdY1S4v5VLtPTVinZmFBkFUK8Meta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/[id].vue")
  },
  {
    name: "my-sarvban-broadcast-ord-list___fa",
    path: "/my-sarvban/broadcast-ord/list",
    meta: { ...(listrAQaIK_45B66uVqLiRoCL8Rs7zBt_456e2TJQH6bgcJLj5UMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/list.vue")
  },
  {
    name: "my-sarvban-broadcast-ord-list___en",
    path: "/en/my-sarvban/broadcast-ord/list",
    meta: { ...(listrAQaIK_45B66uVqLiRoCL8Rs7zBt_456e2TJQH6bgcJLj5UMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/list.vue")
  },
  {
    name: "my-sarvban-broadcast-ord-list___ar",
    path: "/ar/my-sarvban/broadcast-ord/list",
    meta: { ...(listrAQaIK_45B66uVqLiRoCL8Rs7zBt_456e2TJQH6bgcJLj5UMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/list.vue")
  },
  {
    name: "my-sarvban-broadcast-ord-list___ru",
    path: "/ru/my-sarvban/broadcast-ord/list",
    meta: { ...(listrAQaIK_45B66uVqLiRoCL8Rs7zBt_456e2TJQH6bgcJLj5UMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/list.vue")
  },
  {
    name: "my-sarvban-broadcast-ord-list___tr",
    path: "/tr/my-sarvban/broadcast-ord/list",
    meta: { ...(listrAQaIK_45B66uVqLiRoCL8Rs7zBt_456e2TJQH6bgcJLj5UMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/list.vue")
  },
  {
    name: "my-sarvban-buy-requests___fa",
    path: "/my-sarvban/buy-requests",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buy-requests/index.vue")
  },
  {
    name: "my-sarvban-buy-requests___en",
    path: "/en/my-sarvban/buy-requests",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buy-requests/index.vue")
  },
  {
    name: "my-sarvban-buy-requests___ar",
    path: "/ar/my-sarvban/buy-requests",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buy-requests/index.vue")
  },
  {
    name: "my-sarvban-buy-requests___ru",
    path: "/ru/my-sarvban/buy-requests",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buy-requests/index.vue")
  },
  {
    name: "my-sarvban-buy-requests___tr",
    path: "/tr/my-sarvban/buy-requests",
    meta: {"middleware":"auth-my-sarvban"},
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buy-requests/index.vue")
  },
  {
    name: "my-sarvban-broadcast-ord___fa",
    path: "/my-sarvban/broadcast-ord",
    meta: { ...(indexTHZv2_45nOJgs23lb_GVgXYrKB10BJOXU1fGQm6p2HkrsMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/index.vue")
  },
  {
    name: "my-sarvban-broadcast-ord___en",
    path: "/en/my-sarvban/broadcast-ord",
    meta: { ...(indexTHZv2_45nOJgs23lb_GVgXYrKB10BJOXU1fGQm6p2HkrsMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/index.vue")
  },
  {
    name: "my-sarvban-broadcast-ord___ar",
    path: "/ar/my-sarvban/broadcast-ord",
    meta: { ...(indexTHZv2_45nOJgs23lb_GVgXYrKB10BJOXU1fGQm6p2HkrsMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/index.vue")
  },
  {
    name: "my-sarvban-broadcast-ord___ru",
    path: "/ru/my-sarvban/broadcast-ord",
    meta: { ...(indexTHZv2_45nOJgs23lb_GVgXYrKB10BJOXU1fGQm6p2HkrsMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/index.vue")
  },
  {
    name: "my-sarvban-broadcast-ord___tr",
    path: "/tr/my-sarvban/broadcast-ord",
    meta: { ...(indexTHZv2_45nOJgs23lb_GVgXYrKB10BJOXU1fGQm6p2HkrsMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/broadcast-ord/index.vue")
  },
  {
    name: "my-sarvban-buy-requests-edit-id___fa",
    path: "/my-sarvban/buy-requests/edit/:id()",
    meta: { ...(_91id_939wRsc9EUOYJlyyyt3ILuwU_45KfB0uqw5eDvtd9NowjGkMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buy-requests/edit/[id].vue")
  },
  {
    name: "my-sarvban-buy-requests-edit-id___en",
    path: "/en/my-sarvban/buy-requests/edit/:id()",
    meta: { ...(_91id_939wRsc9EUOYJlyyyt3ILuwU_45KfB0uqw5eDvtd9NowjGkMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buy-requests/edit/[id].vue")
  },
  {
    name: "my-sarvban-buy-requests-edit-id___ar",
    path: "/ar/my-sarvban/buy-requests/edit/:id()",
    meta: { ...(_91id_939wRsc9EUOYJlyyyt3ILuwU_45KfB0uqw5eDvtd9NowjGkMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buy-requests/edit/[id].vue")
  },
  {
    name: "my-sarvban-buy-requests-edit-id___ru",
    path: "/ru/my-sarvban/buy-requests/edit/:id()",
    meta: { ...(_91id_939wRsc9EUOYJlyyyt3ILuwU_45KfB0uqw5eDvtd9NowjGkMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buy-requests/edit/[id].vue")
  },
  {
    name: "my-sarvban-buy-requests-edit-id___tr",
    path: "/tr/my-sarvban/buy-requests/edit/:id()",
    meta: { ...(_91id_939wRsc9EUOYJlyyyt3ILuwU_45KfB0uqw5eDvtd9NowjGkMeta || {}), ...{"middleware":"auth-my-sarvban"} },
    component: () => import("/srv/sarvban_front/pages/my-sarvban/buy-requests/edit/[id].vue")
  },
  {
    name: "details-main___fa",
    path: "/details/main/:id",
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-main___en",
    path: "/en/details/main/:id",
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-main___ar",
    path: "/ar/details/main/:id",
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-main___ru",
    path: "/ru/details/main/:id",
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-main___tr",
    path: "/tr/details/main/:id",
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "mci-main___fa",
    path: "/mci",
    component: () => import("/srv/sarvban_front/pages/index.vue")
  },
  {
    name: "mci-main___en",
    path: "/en/mci",
    component: () => import("/srv/sarvban_front/pages/index.vue")
  },
  {
    name: "mci-main___ar",
    path: "/ar/mci",
    component: () => import("/srv/sarvban_front/pages/index.vue")
  },
  {
    name: "mci-main___ru",
    path: "/ru/mci",
    component: () => import("/srv/sarvban_front/pages/index.vue")
  },
  {
    name: "mci-main___tr",
    path: "/tr/mci",
    component: () => import("/srv/sarvban_front/pages/index.vue")
  },
  {
    name: "details-main___fa",
    path: "/mci/details/:id",
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-main___en",
    path: "/en/mci/details/:id",
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-main___ar",
    path: "/ar/mci/details/:id",
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-main___ru",
    path: "/ru/mci/details/:id",
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "details-main___tr",
    path: "/tr/mci/details/:id",
    component: () => import("/srv/sarvban_front/pages/details/[id].vue")
  },
  {
    name: "order-main___fa",
    path: "/order/main/:id",
    component: () => import("/srv/sarvban_front/pages/order/[id].vue")
  },
  {
    name: "order-main___en",
    path: "/en/order/main/:id",
    component: () => import("/srv/sarvban_front/pages/order/[id].vue")
  },
  {
    name: "order-main___ar",
    path: "/ar/order/main/:id",
    component: () => import("/srv/sarvban_front/pages/order/[id].vue")
  },
  {
    name: "order-main___ru",
    path: "/ru/order/main/:id",
    component: () => import("/srv/sarvban_front/pages/order/[id].vue")
  },
  {
    name: "order-main___tr",
    path: "/tr/order/main/:id",
    component: () => import("/srv/sarvban_front/pages/order/[id].vue")
  },
  {
    name: "market-amayesh-region___fa",
    path: "/region/amayesh",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "market-amayesh-region___en",
    path: "/en/region/amayesh",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "market-amayesh-region___ar",
    path: "/ar/region/amayesh",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "market-amayesh-region___ru",
    path: "/ru/region/amayesh",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "market-amayesh-region___tr",
    path: "/tr/region/amayesh",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "market-amayesh___fa",
    path: "/amayesh",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "market-amayesh___en",
    path: "/en/amayesh",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "market-amayesh___ar",
    path: "/ar/amayesh",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "market-amayesh___ru",
    path: "/ru/amayesh",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "market-amayesh___tr",
    path: "/tr/amayesh",
    component: () => import("/srv/sarvban_front/pages/region/amayesh/index.vue")
  },
  {
    name: "market-cat___fa",
    path: "/cat/:advType/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___en",
    path: "/en/cat/:advType/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___ar",
    path: "/ar/cat/:advType/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___ru",
    path: "/ru/cat/:advType/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___tr",
    path: "/tr/cat/:advType/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___fa",
    path: "/cat/:advType/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___en",
    path: "/en/cat/:advType/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___ar",
    path: "/ar/cat/:advType/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___ru",
    path: "/ru/cat/:advType/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___tr",
    path: "/tr/cat/:advType/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___fa",
    path: "/cat/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___en",
    path: "/en/cat/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___ar",
    path: "/ar/cat/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___ru",
    path: "/ru/cat/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat___tr",
    path: "/tr/cat/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat-simple___fa",
    path: "/cat/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat-simple___en",
    path: "/en/cat/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat-simple___ar",
    path: "/ar/cat/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat-simple___ru",
    path: "/ru/cat/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-cat-simple___tr",
    path: "/tr/cat/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-tag-simple___fa",
    path: "/tag/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-tag-simple___en",
    path: "/en/tag/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-tag-simple___ar",
    path: "/ar/tag/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-tag-simple___ru",
    path: "/ru/tag/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-tag-simple___tr",
    path: "/tr/tag/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-tag___fa",
    path: "/tag/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-tag___en",
    path: "/en/tag/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-tag___ar",
    path: "/ar/tag/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-tag___ru",
    path: "/ru/tag/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-tag___tr",
    path: "/tr/tag/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-search___fa",
    path: "/search/:key/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-search___en",
    path: "/en/search/:key/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-search___ar",
    path: "/ar/search/:key/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-search___ru",
    path: "/ru/search/:key/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-search___tr",
    path: "/tr/search/:key/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-search-simple___fa",
    path: "/search/:key",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-search-simple___en",
    path: "/en/search/:key",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-search-simple___ar",
    path: "/ar/search/:key",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-search-simple___ru",
    path: "/ru/search/:key",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-search-simple___tr",
    path: "/tr/search/:key",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-kind___fa",
    path: "/kind/:advType/:kindId/:kindTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-kind___en",
    path: "/en/kind/:advType/:kindId/:kindTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-kind___ar",
    path: "/ar/kind/:advType/:kindId/:kindTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-kind___ru",
    path: "/ru/kind/:advType/:kindId/:kindTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-kind___tr",
    path: "/tr/kind/:advType/:kindId/:kindTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products-seller___fa",
    path: "/products/seller",
    component: () => import("/srv/sarvban_front/pages/products/seller.vue")
  },
  {
    name: "products-seller___en",
    path: "/en/products/seller",
    component: () => import("/srv/sarvban_front/pages/products/seller.vue")
  },
  {
    name: "products-seller___ar",
    path: "/ar/products/seller",
    component: () => import("/srv/sarvban_front/pages/products/seller.vue")
  },
  {
    name: "products-seller___ru",
    path: "/ru/products/seller",
    component: () => import("/srv/sarvban_front/pages/products/seller.vue")
  },
  {
    name: "products-seller___tr",
    path: "/tr/products/seller",
    component: () => import("/srv/sarvban_front/pages/products/seller.vue")
  },
  {
    name: "products-outofseasion___fa",
    path: "/products/outofseasion",
    component: () => import("/srv/sarvban_front/pages/products/outofseasion.vue")
  },
  {
    name: "products-outofseasion___en",
    path: "/en/products/outofseasion",
    component: () => import("/srv/sarvban_front/pages/products/outofseasion.vue")
  },
  {
    name: "products-outofseasion___ar",
    path: "/ar/products/outofseasion",
    component: () => import("/srv/sarvban_front/pages/products/outofseasion.vue")
  },
  {
    name: "products-outofseasion___ru",
    path: "/ru/products/outofseasion",
    component: () => import("/srv/sarvban_front/pages/products/outofseasion.vue")
  },
  {
    name: "products-outofseasion___tr",
    path: "/tr/products/outofseasion",
    component: () => import("/srv/sarvban_front/pages/products/outofseasion.vue")
  },
  {
    name: "market-products-type___fa",
    path: "/products/:advType/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-type___en",
    path: "/en/products/:advType/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-type___ar",
    path: "/ar/products/:advType/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-type___ru",
    path: "/ru/products/:advType/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-type___tr",
    path: "/tr/products/:advType/:catId/:catTitle",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-cat___fa",
    path: "/products/:advType/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-cat___en",
    path: "/en/products/:advType/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-cat___ar",
    path: "/ar/products/:advType/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-cat___ru",
    path: "/ru/products/:advType/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-cat___tr",
    path: "/tr/products/:advType/:catId",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products___fa",
    path: "/products/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products___en",
    path: "/en/products/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products___ar",
    path: "/ar/products/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products___ru",
    path: "/ru/products/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products___tr",
    path: "/tr/products/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-mci___fa",
    path: "/mci/products/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-mci___en",
    path: "/en/mci/products/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-mci___ar",
    path: "/ar/mci/products/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-mci___ru",
    path: "/ru/mci/products/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "market-products-mci___tr",
    path: "/tr/mci/products/:advType",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products-mci___fa",
    path: "/mci/products",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products-mci___en",
    path: "/en/mci/products",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products-mci___ar",
    path: "/ar/mci/products",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products-mci___ru",
    path: "/ru/mci/products",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products-mci___tr",
    path: "/tr/mci/products",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products-services___fa",
    path: "/services",
    component: () => import("/srv/sarvban_front/pages/products/services.vue")
  },
  {
    name: "products-services___en",
    path: "/en/services",
    component: () => import("/srv/sarvban_front/pages/products/services.vue")
  },
  {
    name: "products-services___ar",
    path: "/ar/services",
    component: () => import("/srv/sarvban_front/pages/products/services.vue")
  },
  {
    name: "products-services___ru",
    path: "/ru/services",
    component: () => import("/srv/sarvban_front/pages/products/services.vue")
  },
  {
    name: "products-services___tr",
    path: "/tr/services",
    component: () => import("/srv/sarvban_front/pages/products/services.vue")
  },
  {
    name: "products-root___fa",
    path: "/products",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products-root___en",
    path: "/en/products",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products-root___ar",
    path: "/ar/products",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products-root___ru",
    path: "/ru/products",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "products-root___tr",
    path: "/tr/products",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-zara___fa",
    path: "/product/zara",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-zara___en",
    path: "/en/product/zara",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-zara___ar",
    path: "/ar/product/zara",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-zara___ru",
    path: "/ru/product/zara",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-zara___tr",
    path: "/tr/product/zara",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-roostabad___fa",
    path: "/product/rostabad",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-roostabad___en",
    path: "/en/product/rostabad",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-roostabad___ar",
    path: "/ar/product/rostabad",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-roostabad___ru",
    path: "/ru/product/rostabad",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-roostabad___tr",
    path: "/tr/product/rostabad",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-roostabad-alt___fa",
    path: "/product/roostabad",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-roostabad-alt___en",
    path: "/en/product/roostabad",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-roostabad-alt___ar",
    path: "/ar/product/roostabad",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-roostabad-alt___ru",
    path: "/ru/product/roostabad",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "product-roostabad-alt___tr",
    path: "/tr/product/roostabad",
    component: () => import("/srv/sarvban_front/pages/products/index.vue")
  },
  {
    name: "my-adv___fa",
    path: "/my-adv",
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/index.vue")
  },
  {
    name: "my-adv___en",
    path: "/en/my-adv",
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/index.vue")
  },
  {
    name: "my-adv___ar",
    path: "/ar/my-adv",
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/index.vue")
  },
  {
    name: "my-adv___ru",
    path: "/ru/my-adv",
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/index.vue")
  },
  {
    name: "my-adv___tr",
    path: "/tr/my-adv",
    component: () => import("/srv/sarvban_front/pages/my-sarvban/adv/index.vue")
  },
  {
    name: "gheymzatban___fa",
    path: "/region/bar/:city",
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "gheymzatban___en",
    path: "/en/region/bar/:city",
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "gheymzatban___ar",
    path: "/ar/region/bar/:city",
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "gheymzatban___ru",
    path: "/ru/region/bar/:city",
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "gheymzatban___tr",
    path: "/tr/region/bar/:city",
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "gheymzatban-index___fa",
    path: "/region/bar",
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "gheymzatban-index___en",
    path: "/en/region/bar",
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "gheymzatban-index___ar",
    path: "/ar/region/bar",
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "gheymzatban-index___ru",
    path: "/ru/region/bar",
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: "gheymzatban-index___tr",
    path: "/tr/region/bar",
    component: () => import("/srv/sarvban_front/pages/region/bar/[city].vue")
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/_nuxt",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/en/_nuxt",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/ar/_nuxt",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/ru/_nuxt",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/tr/_nuxt",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/products/buy",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/en/products/buy",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/ar/products/buy",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/ru/products/buy",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/tr/products/buy",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/ar/sitemap.xml",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/ru/sitemap.xml",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  },
  {
    name: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08Meta?.name,
    path: "/tr/sitemap.xml",
    component: component_45stubZk3YOfqleiwihg8p1IHJjB9FjfCOLpp1r1lnHMJlS08
  }
]